var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-flag-box"},[(_vm.enable)?_c('span',{staticClass:"use"},[_vm._v(_vm._s(_vm.$t("base.enabled")))]):_c('span',{staticClass:"unuse"},[_vm._v(_vm._s(_vm.$t("base.disable")))])])}
var staticRenderFns = []

export { render, staticRenderFns }